import React, { useState } from "react";
import Context from "./index";
import { getAll, create, getSingle } from "../../Api/AuthApi";
import { message, Form } from "antd";
const AdBannerProvider = ({ children, ...props }) => {
  const [adBannerList, setAdBannerList] = useState([]);
  const [adBannerSingle, setAdBannerSingle] = useState({});
  const [adBannerListLoader, setAdBannerListLoader] = useState(false);
  const [adBannerListFilter, setAdBannerListFilter] = useState({
    limit: 10,
    page: 1,
    banner_name: "",
  });
  const [adBannerPopup, setAdBannerPopup] = useState(false);
  const [adBannerViewPopup, setAdBannerViewPopup] = useState(false);
  const [adBannerEditPopup, setAdBannerEditPopup] = useState(false);
  const [adBannerAddLoader, setAdBannerAddLoader] = useState(false);
  const [adBannerEditLoader, setAdBannerEditLoader] = useState(false);
  const [adBannerSingleLoader, setAdBannerSingleLoader] = useState(false);
  const [adBannerForm] = Form.useForm();
  const [adBannerFormEdit] = Form.useForm();
  const [currentBannerID, setCurrentBannerID] = useState(null);
  const [bannerImageRemoveLoader, setAdBannerImageRemoveLoader] = useState(false);
  const [adDeleteBannerLoader, setAdDeleteBannerLoader] =
    useState(false);

  async function adBannerRemoveImage(id = null, image_type = null) {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdBannerImageRemoveLoader(true);
    await getAll(
      "banner.php?action=pro_feature_promo_img_upload_remove&banner_id=" +
        id +
        "&image_type=" +
        image_type,
      {}
    )
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setAdBannerImageRemoveLoader(false);
        } else {
          setAdBannerImageRemoveLoader(false);
        }
      })
      .catch((err) => {
        setAdBannerImageRemoveLoader(false);
      });
  }


  async function adBannerListFetch() {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdBannerListLoader(true);
    await getAll("banner.php?action=bannerlist", adBannerListFilter)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setAdBannerList(res?.data);
          setAdBannerListLoader(false);
        } else {
          setAdBannerList([]);
          setAdBannerListLoader(false);
        }
      })
      .catch((err) => {
        setAdBannerList([]);
        setAdBannerListLoader(false);
      });
  }
  async function adBannerAdd(data = {}) {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdBannerAddLoader(true);
    const form_data = new FormData();
    form_data.append("banner_name", data?.banner_name || "");
    form_data.append("desktop_image", data?.desktop_image || "");
    form_data.append("mobile_image", data?.mobile_image || "");
    form_data.append("banner_link", data?.banner_link || "");
    form_data.append("banner_order", data?.banner_order || 0);
    form_data.append("status", data?.status === true ? 1 : 0 || 1);
   
    await create("banner.php?action=bannercreate", form_data)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setAdBannerPopup(false);
          adBannerForm.resetFields();
          setAdBannerAddLoader(false);
          adBannerListFetch();
        } else {
          message.error(res?.message);
          setAdBannerAddLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setAdBannerAddLoader(false);
      });
  }

  async function adBannerSingleFetch(id) {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdBannerSingleLoader(true);
    await getSingle(`banner.php?action=bannersingle&id=${id}`)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setAdBannerSingle(res?.data);
          adBannerFormEdit.setFieldsValue({
            ...res?.data,
            Banner_status: res?.data?.Banner_status === "1" ? true : false,
          });
          setAdBannerSingleLoader(false);
        } else {
          setAdBannerSingle({});
          setAdBannerSingleLoader(false);
        }
      })
      .catch((err) => {
        setAdBannerSingle({});
        setAdBannerSingleLoader(false);
      });
  }

  async function adBannerUpdate(
    data = {},
  ) {
    const token_data = localStorage.getItem("nattu_admin_token");
    if (!token_data) return;
    setAdBannerEditLoader(true);
    const form_data = new FormData();
    form_data.append("banner_name", data?.banner_name || "");
    form_data.append("desktop_image", data?.desktop_image || "");
    form_data.append("mobile_image", data?.mobile_image || "");
    form_data.append("banner_link", data?.banner_link || "");
    form_data.append("banner_order", data?.banner_order || 0);
    form_data.append("status", data?.status === true ? 1 : 0);
    await create(
      "banner.php?action=bannerupdate&banner_id=" + currentBannerID,
      form_data
    )
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setAdBannerEditPopup(false);
          adBannerFormEdit.resetFields();
          setAdBannerEditLoader(false);
          adBannerListFetch();
        } else {
          message.error(res?.message);
          setAdBannerEditLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setAdBannerEditLoader(false);
      });
  }

  async function adDeleteBanner(id) {
      const token_data = localStorage.getItem("nattu_admin_token");
      if (!token_data) return;
      setAdDeleteBannerLoader(true);
      await getAll(`banner.php?action=bannerdelete&banner_id=${id}`)
        .then((res) => {
          if (res?.status === 200 && res?.success === true) {
            adBannerListFetch();
            setAdDeleteBannerLoader(false);
          } else {
            setAdDeleteBannerLoader(false);
          }
        })
        .catch((err) => {
          setAdDeleteBannerLoader(false);
        });
    }


  return (
    <Context.Provider
      value={{
        ...props,
        adBannerListFetch,
        adBannerList,
        setAdBannerList,
        adBannerListLoader,
        setAdBannerListLoader,
        adBannerListFilter,
        setAdBannerListFilter,
        adBannerPopup,
        setAdBannerPopup,
        adBannerAddLoader,
        setAdBannerAddLoader,
        adBannerAdd,
        adBannerForm,
        adBannerSingleFetch,
        adBannerSingle,
        adBannerSingleLoader,
        setAdBannerSingleLoader,
        adBannerViewPopup,
        setAdBannerViewPopup,
        adBannerEditPopup,
        setAdBannerEditPopup,
        adBannerFormEdit,
        adBannerUpdate,
        adBannerEditLoader,
        setAdBannerEditLoader,
        currentBannerID,
        setCurrentBannerID,
        bannerImageRemoveLoader,
        setAdBannerImageRemoveLoader,
        adBannerRemoveImage,
        adDeleteBannerLoader,
        setAdDeleteBannerLoader,
        adDeleteBanner,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AdBannerProvider;
